import clsx from 'clsx';
import { FolderPlus } from 'lucide-react';
import { useSettingsStore } from '../../stores/settings-store';
import { TopBar } from './TopBar';
import { GrapesEditor } from '../editor/GrapesEditor';
import { LayersPanel } from '../editor/LayersPanel';
import { StylesPanel } from '../editor/StylesPanel';
import { PagesPanel } from '../pages/PagesPanel';
import { PromptInput } from '../prompt/PromptInput';
import { SettingsDialog } from '../settings/SettingsDialog';
import { GenerationSettingsDialog } from '../settings/GenerationSettingsDialog';
import { PromptLoaderOverlay } from '../prompt/PromptLoaderOverlay';
import { FloatingEditPanel } from '../editor/FloatingEditPanel';
import { useProjectsStore } from '../../stores/projects-store';

export function AppShell() {
  const sidebarOpen = useSettingsStore((s) => s.sidebarOpen);
  const layersOpen = useSettingsStore((s) => s.layersOpen);
  const stylesOpen = useSettingsStore((s) => s.stylesOpen);
  const toggleSidebar = useSettingsStore((s) => s.toggleSidebar);
  const toggleLayers = useSettingsStore((s) => s.toggleLayers);
  const toggleStyles = useSettingsStore((s) => s.toggleStyles);
  const currentProject = useProjectsStore((s) => s.currentProject);

  return (
    <div className="h-screen flex overflow-hidden bg-surface text-text">
      {/* Projects Sidebar */}
      <div
        className={clsx(
          'shrink-0 bg-surface-light border-r border-surface-lighter transition-all duration-200 overflow-hidden',
          sidebarOpen ? 'w-64' : 'w-10'
        )}
      >
        <PagesPanel collapsed={!sidebarOpen} onToggle={toggleSidebar} />
      </div>

      {/* Layers Panel */}
      <div
        className={clsx(
          'shrink-0 transition-all duration-200 overflow-hidden',
          layersOpen ? 'w-72' : 'w-10'
        )}
      >
        <LayersPanel collapsed={!layersOpen} onToggle={toggleLayers} />
      </div>

      {/* Main area */}
      <div className="flex-1 flex flex-col min-w-0">
        <TopBar />
        {currentProject ? (
          <>
            <GrapesEditor />
            <PromptInput />
          </>
        ) : (
          <div className="flex-1 flex items-center justify-center bg-surface">
            <div className="flex flex-col items-center gap-3 text-center px-6">
              <div className="w-14 h-14 rounded-xl bg-surface-light border border-surface-lighter flex items-center justify-center">
                <FolderPlus size={24} className="text-accent" />
              </div>
              <h2 className="text-lg font-semibold text-text">Select a project</h2>
              <p className="text-sm text-text-muted">Go back to the cabinet to open or create a project.</p>
            </div>
          </div>
        )}
      </div>

      {/* Styles Panel */}
      <div
        className={clsx(
          'shrink-0 transition-all duration-200 overflow-hidden',
          stylesOpen ? 'w-80' : 'w-10'
        )}
      >
        <StylesPanel collapsed={!stylesOpen} onToggle={toggleStyles} />
      </div>

      {/* Modals */}
      <SettingsDialog />
      <GenerationSettingsDialog />
      <PromptLoaderOverlay />
      <FloatingEditPanel />
    </div>
  );
}
